export default [
  {
    path: '/app/categories',
    name: 'Categories',
    component: () => import('@/views/Categories/Index.vue'),
    meta: {
      pageTitle: 'Kategoriler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'CATEGORY_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/categories/add',
    name: 'CategoryAdd',
    component: () => import('@/views/Categories/Add.vue'),
    meta: {
      pageTitle: 'Kategoriler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/categories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'CATEGORY_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/categories/edit/:id',
    name: 'CategoryEdit',
    component: () => import('@/views/Categories/Edit.vue'),
    meta: {
      pageTitle: 'Kategoriler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/categories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'CATEGORY_EDIT',
      action: 'read',
    },
  },
]
